import {string as originString} from 'yup';

export const string = () => originString().ensure();
